
define( 'FORCES_AND_MOTION_BASICS/../nls/gl/forces-and-motion-basics-strings',{
          "none": "Nada",
          "force": "Forza",
          "values": "Valores",
          "frictionTitle": "Rozamento",
          "redWins": "Vermello gaña!",
          "frictionForce": "Forza de Rozamento",
          "pause": "Pausa",
          "friction": "Rozamento",
          "forces-and-motion-basics.name": "Forzase movemento: Inicial",
          "appliedForce": "Forza aplicada",
          "leftForce": "Forza esquerda",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Forza dereita",
          "sound": "Son",
          "lots": "Moito",
          "forces": "Forzas",
          "motion": "Movemento",
          "tugOfWar": "Remolcador",
          "go": "Adiante!",
          "newtons.n": "Newtons (N)",
          "sumOfForcesEqualsZero": "Suma de forzas = 0",
          "blueWins": "Azul gaña!",
          "speed": "Velocidade",
          "sumOfForces": "Suma de forzas",
          "return": "Volver",
          "translation.credits": "<html><center>Ramón Cid<br>IES de SAR<br>\nSantiago (Spain)<br>\nwww.lhc-closer.es<html>",
          "newtons": "Newtons",
          "masses": "Masas",
          "forceReadout.pattern": "{0}N"
        } );